import template from './leftnav.html';
import LeftnavController from './leftnav.controller';
import './leftnav.styl';

let leftNavComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller: LeftnavController,
  controllerAs: 'vm'
};

export default leftNavComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/leftnav/leftnav.component.js
 **/